<form [formGroup]="form">

  <div class="cdc-form-field" [ngClass]="{'actif': multipleAnswers || isGroup}">
    <div class="cdc-label">
      {{ "Min quantity" | translate }}
    </div>
    <div class="cdc-label-description">
      {{"Range between" | translate}} (1-max)
    </div>

    <input matInput type="number" formControlName="minQuantity">
  </div>

  <div class="cdc-form-field" [ngClass]="{'actif': multipleAnswers || isGroup}">
    <div class="cdc-label">
      {{ "Max quantity" | translate }}
    </div>
    <div class="cdc-label-description">
      {{"Range between" | translate}} (min-ꝏ)
    </div>

    <input matInput type="number" formControlName="maxQuantity">
  </div>

  <div class="cdc-form-field" [ngClass]="{'actif': multipleAnswers || isGroup}">
    <div class="cdc-label">
      {{ "Initial quantity" | translate }}
    </div>
    <div class="cdc-label-description">
      {{"Range between" | translate}} (min-max)
    </div>

    <input matInput type="number" formControlName="initQuantity">
  </div>

  <div class="cdc-form-field" [ngClass]="{'actif': multipleAnswers || isGroup}" *ngIf="form.get('maxQuantity')?.value === null || form.get('maxQuantity')?.value === undefined || form.get('maxQuantity')?.value > 1">
    <div class="cdc-label">
      {{ "Button text for adding multiple" | translate }}
    </div>

    <input matInput type="text" formControlName="textBtnMultiple" (change)="newUpdateListener()">
  </div>

  <div class="cdc-form-field">
    <mat-checkbox [checked]="form.get('haveIndexTitles')" formControlName="haveIndexTitles" *ngIf="hasIndexText === true" (change)="newUpdateListener()">
      <span *ngIf="isGroup">{{ 'Index titles' | translate }}</span>
      <span *ngIf="!isGroup">{{ 'Index placeholders' | translate }}</span>
    </mat-checkbox>
  </div>
</form>
